import {
  AnswerAreaPinComponent,
  HotspotPinComponent,
  ImagePinComponent,
  LinePinComponent,
  PinComponent,
  ShapePinComponent,
  TextPinComponent,
} from '@lessonup/pins-shared';
import {
  DEFAULT_CONTENT_FILL_COLOR,
  DEFAULT_CONTENT_ON_COLOR,
} from '../../pinComponents/HotspotPinComponent/hotspot.utils';
import { getDefaultBackgroundColor } from './pinComponent.utils';

export function isPinComponentLocked(pinComponent: PinComponent): boolean {
  return pinComponent.settings.lockLayout ?? false;
}

export function getPinComponentFillColor(pinComponent: ShapePinComponent | LinePinComponent) {
  return pinComponent.settings.fillColor ?? '#000000';
}

export function getPinComponentInnerColor(pinComponent: HotspotPinComponent) {
  return pinComponent.settings.innerColor ?? '#000000';
}

export function getPinComponentBackgroundColor(
  pinComponent: HotspotPinComponent | TextPinComponent | AnswerAreaPinComponent
) {
  return pinComponent.settings.backgroundColor ?? getDefaultBackgroundColor(pinComponent);
}

export function getPinComponentBorderColor(pinComponent: HotspotPinComponent | TextPinComponent | ImagePinComponent) {
  return pinComponent.settings.borderColor ?? '#000000';
}

export function getPinComponentContentBackgroundColor(pinComponent: HotspotPinComponent) {
  return pinComponent.settings.contentBackgroundColor ?? DEFAULT_CONTENT_FILL_COLOR;
}

export function getPinComponentContentTextColor(pinComponent: HotspotPinComponent) {
  return pinComponent.settings.contentTextColor ?? DEFAULT_CONTENT_ON_COLOR;
}
